<template>
    <div class="act-group-buy-vip">
        <div class="scroller">
            <div class="whole-bg">
                <div class="login-sec">
                    <div class="dv1">
                        亲爱的玩家，<template v-if="!isLogin">请<span class="login-btn" @click="enterLogin">【登录】</span></template>
                    </div>
                    <div>您的好友{{ username }}邀您拼团开通乐速盒子{{ groupVipGoodsInfo.name }}</div>
                </div>
                <div class="main-info">
                    <div class="title">乐速盒子拼团福利活动</div>
                    <div class="line"></div>
                    <div class="center-info">
                        <div class="goods-info-wrap">
                            <div class="goods-info">
                                <div class="icon" v-if="showVipGoodsIcon(groupVipGoodsInfo) === 'vip1'"></div>
                                <div class="inner" :class="[`${showVipGoodsIcon(groupVipGoodsInfo)}`]">
                                    <div class="dv1">
                                        {{ groupVipGoodsInfo.name }}
                                    </div>
                                    <div class="dv2">
                                        <!-- 优先按照"原价展示渠道"逻辑展示价格 -->
                                        <template v-if="groupVipGoodsInfo.showOriginPrice">
                                            <span class="sp1">
                                                <i class="i0">仅售</i>
                                                <i class="i1">¥</i>
                                                <i class="i2">{{ groupVipGoodsInfo.original_price }}</i>
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span class="sp1">
                                                <i class="i0">仅售</i>
                                                <i class="i1">¥</i>
                                                <i class="i2">{{ groupVipGoodsInfo.current_price }}</i>
                                            </span>
                                            <span class="sp2" v-if="groupVipGoodsInfo.original_price * 100 !== groupVipGoodsInfo.current_price * 100 && groupVipGoodsInfo.original_price * 100 > groupVipGoodsInfo.current_price * 100">
                                                <i>原价</i>
                                                <i>{{ groupVipGoodsInfo.original_price }}</i>
                                            </span>
                                        </template>
                                    </div>
                                    <div class="dv4">全场游戏免费畅玩尊享{{ groupVipGoodsInfo.name }}</div>
                                </div>
                            </div>
                            <div class="user-info">
                                <div class="title">开通会员 免费畅玩</div>
                                <div class="price-sec">
                                    <span class="sp1">拼团优惠</span>
                                    <span class="sp2">¥</span>
                                    <span class="sp3">{{ groupVipGoodsInfo.group_price }}</span>
                                    <span class="sp4">¥&nbsp;{{ groupVipGoodsInfo.showOriginPrice ? groupVipGoodsInfo.original_price : groupVipGoodsInfo.current_price }}</span>
                                </div>
                                <div class="line">
                                    <div class="discount">
                                        <div class="dv1">已优惠</div>
                                        <div class="dv2 ellipsis">
                                            <i class="i1">¥</i>
                                            <i class="i2">{{ subsidyPrice(groupVipGoodsInfo) }}</i>
                                        </div>
                                    </div>
                                </div>
                                <div class="countdown">
                                    <span class="sp1">{{ countdownStr.slice(0, 2) }}</span>
                                    <span class="sp2">:</span>
                                    <span class="sp1">{{ countdownStr.slice(2, 4) }}</span>
                                    <span class="sp2">:</span>
                                    <span class="sp1">{{ countdownStr.slice(4) }}</span>
                                    <span class="sp3">后结束</span>
                                </div>
                                <div class="invite-info">
                                    <div class="item1">
                                        <img v-if="avatar(1)" :src="avatar(1)" alt="用户头像" />
                                        <div class="icon">团长</div>
                                    </div>
                                    <div class="item2">
                                        <img v-if="avatar(2)" :src="avatar(2)" alt="用户头像" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right-icon">
                            <div class="item">
                                <div class="icon"></div>
                                <div class="text">海量正版游戏</div>
                            </div>
                            <div class="item">
                                <div class="icon"></div>
                                <div class="text">MOD一键安装</div>
                            </div>
                            <div class="item">
                                <div class="icon"></div>
                                <div class="text">会员专享购</div>
                            </div>
                            <div class="item">
                                <div class="icon"></div>
                                <div class="text">云存档保障</div>
                            </div>
                        </div>
                    </div>
                    <div class="btn">
                        <span key="1" v-if="canCreateGroupVipOrder" v-throttle="[buy, 'click', 1000]">确认拼团</span>
                        <span key="2" v-else v-throttle="[dlBox, 'click', 1000]">下载客户端</span>
                    </div>
                </div>
                <div class="activity-rules">
                    <div class="rules-title">活动规则</div>
                    <div class="divide-line"></div>
                    <div class="rules-cnt">
                        <div class="one-level">特别提醒：</div>
                        <div class="two-level"><span class="icon"></span>参与活动前，请仔细阅读活动规则的各个条款，用户参与本活动即视为已充分阅读、理解本活动规则，并自愿受活动规则的约束。</div>
                    </div>
                    <div class="rules-cnt">
                        <div class="one-level">规则明细：</div>
                        <div class="two-level">
                            <div class="icon"></div>
                            <div class="dv">活动期间所有用户每天不限制开团次数，但只能成功达成一次活动拼团。任意档位会员套餐拼团成功后即视为达成拼团，不可再参与其他档位活动。</div>
                        </div>
                        <div class="two-level">
                            <div class="icon"></div>
                            <div class="dv">拼团活动因超时未拼成、商品售罄等原因取消时，开团人和已邀请好友的订单均会自动退款，退款将于3天内原路退回。</div>
                        </div>
                        <div class="two-level">
                            <div class="icon"></div>
                            <div class="dv">活动动时间为每日00:00-24:00，且成团有效期为24小时，开团人需在规定时间内邀请对应数量且满足参团要求的好友完成参团。</div>
                        </div>
                        <div class="two-level">
                            <div class="icon"></div>
                            <div class="dv">具体可购买商品、优惠价格与库存信息以实际展示为准，若所有可拼团商品售罄时用户仍未成团，系统会自动取消未成团的订单。 拼团活动因超时未拼成、商品售罄等原因取消时，开团人和已邀请好友的订单均会自动退款，退款将于3天内原路退回。</div>
                        </div>
                    </div>
                    <div class="rules-cnt">
                        <div class="one-level">注意事项：</div>
                        <div class="two-level">
                            <div class="icon"></div>
                            <div class="dv">活动期间如出现不可抗力或情势变更，包括但不限于重大灾害事件、黑客攻击、系统故障、活动受政府机关指令需停止举办或调整的，活动举办方可依据相关法律法规调整/暂停或提前终止活动。</div>
                        </div>
                        <div class="two-level">
                            <div class="icon"></div>
                            <div class="dv">用户不得使用任何外挂、插件以及其他破坏活动规则、违背活动公平原则的方式参与本次活动（如批量注册、恶意购买、虚假分享、倒买倒卖、虚假交易等），否则活动举办方有权取消用户参与活动资格，追回已经领取或者使用的优惠权益，并在必要时取消后续参与任意活动的权利，同时追究法律责任。</div>
                        </div>
                        <div class="two-level">
                            <div class="icon"></div>
                            <div class="dv">若市场环境、参与情况变动，活动举办方将对活动参与时间与活动规则进行调整，请以页面展示的最新规则为准。</div>
                        </div>
                        <div class="two-level">
                            <div class="icon"></div>
                            <div class="dv">如您在使用我方产品过程中遇到任何问题，请咨询客服。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Decimal from 'decimal.js'
import config from '@/http/config'
import { getCookieToken, canPlayGame } from '@/utils/auth'
import { mapState } from 'vuex'
import { getUserGroupInfo, getGroupInfo } from '@/http/api/activity'
import { formatTime2 } from '@/utils/date'

export default {
    name: 'ActGroupBuyVip',
    data() {
        return {
            orderStatus: [1, 2, 3, 4, 5, 6],
            groupVipGoodsInfo: {},
            userGroupInfo: {}, // 用户的拼团信息
            inviteUserGroupInfo: {}, // 邀请好友的拼团信息（团长信息）
            chooseGoods: {},
            defautlAvatar: require('@/assets/default.png'),
            moreDefautlAvatar: require('@/assets/dialog/more-join-avatar.png'),
            leftTime: 0, // 拼团剩余时间
            countdownStr: '000000'
        }
    },
    computed: {
        ...mapState(['userInfo', 'serverTime', 'authInfo', 'authConfig']),
        isLogin() {
            return this.userInfo.id
        },
        avatar: function () {
            return (type) => {
                // 拼团信息不存在
                if (!this.inviteUserGroupInfo.id) {
                    return ''
                }
                // type 1--开团的人头像 2--参团的人头像（存在多个参团人）
                const joinUserInfoList = this.inviteUserGroupInfo?.join_list?.filter((v) => this.orderStatus.indexOf(v.order_status) > -1) || []
                // 没有参团人直接返回空或者有参团人订单状态不符合
                if (type === 2 && !joinUserInfoList.length) {
                    return ''
                }
                let avatar = ''
                if (type === 1) {
                    avatar = this.inviteUserGroupInfo.avatar
                } else if (joinUserInfoList.legnth === 1) {
                    avatar = joinUserInfoList[0].avatar
                }

                if (!avatar) {
                    if (joinUserInfoList.legnth > 1) {
                        return this.moreDefautlAvatar
                    }
                    return this.defautlAvatar
                } else if (avatar.indexOf('thirdwx.qlogo.cn') > -1) {
                    return avatar
                } else {
                    return config.PREVIEW_DOMAIN + avatar
                }
            }
        },
        showVipGoodsIcon() {
            return (item) => {
                let className = ''
                if (!item) {
                    return
                }
                if (!item?.name) {
                    className = ''
                } else if (item.name.indexOf('永久会员') > -1) {
                    className = 'vip1'
                } else if (item.name.indexOf('365天会员') > -1) {
                    className = 'vip2'
                } else if (item.name.indexOf('30天会员') > -1) {
                    className = 'vip3'
                }
                return className
            }
        },
        subsidyPrice() {
            return (item) => {
                if (!item.id) {
                    return 0
                }
                const payPrice = item.showOriginPrice ? item.original_price : item.current_price
                return Math.abs(new Decimal(payPrice).minus(new Decimal(item.group_price)).toNumber())
            }
        },
        // 开团人是否可以再次开团
        canCreateGroupVipOrder() {
            const { latest_main = {}, latest_join = {} } = this.userGroupInfo
            // 开团信息中显示是拼团中、拼团成功并且订单状态在this.orderStatus中
            if ((latest_main.status === 1 || latest_main.status === 2) && this.orderStatus.indexOf(latest_main.order_status) > -1) {
                return false
            } else {
                // 参信息中主团显示是拼团中、拼团成功，并且参团人的订单状态在this.orderStatus中
                const hasJoinInfo = latest_join.join_list?.find((v) => v.user_id === this.userInfo.id) || {}
                if ((latest_join.status === 1 || latest_join.status === 2) && this.orderStatus.indexOf(hasJoinInfo.order_status) > -1) {
                    return false
                } else {
                    return true
                }
            }
        },
        username: function () {
            const name = this.inviteUserGroupInfo.user_name,
                reg = /^1[3-9]\d{9}$/
            let displayNmae = ''
            if (reg.test(name)) {
                displayNmae = this.$Utils.formatPhoneNumber(name)
            } else {
                displayNmae = name
            }
            return displayNmae
        }
    },
    watch: {
        userInfo: {
            deep: true,
            handler(newVal) {
                if (newVal.id) {
                    this.buy()
                }
            }
        },
        serverTime: {
            immediate: true,
            handler(newVal) {
                const { start_time, expire_time } = this.inviteUserGroupInfo
                if (start_time && expire_time) {
                    this.leftTime = Math.ceil((+new Date(expire_time) - newVal * 1000) / 1000)
                    const showTime = Math.max(0, this.leftTime)
                    this.countdownStr = formatTime2(showTime)
                }
            }
        }
    },
    mounted() {
        const { group_id } = this.$route.query
        this.group_id = !isNaN(parseInt(group_id)) ? parseInt(group_id) : 0
        this.getGroupInfo()
        this.$EventBus.$on('refresh-group-info', () => {
            this.getGroupInfo()
            this.getUserGroupInfo()
        })
    },
    methods: {
        // 获取当前用户的参团信息
        getUserGroupInfo() {
            if (!getCookieToken()) {
                return
            }
            getUserGroupInfo().then((res) => {
                if (res.code === 200 && this.$Utils.isObject(res.data)) {
                    this.userGroupInfo = res.data
                }
            })
        },
        // 获取当前团的拼团信息
        getGroupInfo() {
            const showToast = !getCookieToken()
            if (this.group_id <= 0) {
                showToast && this.$Toast.show('当前拼团信息不存在或已失效')
                return
            }

            getGroupInfo({ id: this.group_id })
                .then((res) => {
                    if (res.code === 200 && this.$Utils.isObject(res.data)) {
                        this.inviteUserGroupInfo = res.data
                        this.groupVipGoodsInfo = { ...res.data.goods_info, group_id: res.data.id }
                    } else {
                        showToast && this.$Toast.show('当前拼团信息不存在或已失效')
                    }
                })
                .catch((err) => {
                    console.log('[getGroupInfo]=======>', err)
                })
        },
        // 拼团购买
        async buy() {
            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {}
                })
            }
            // 是否实名认证过
            await this.$Utils.waitForAuthInfo()
            if (
                !canPlayGame(this, () => {
                    this.buy()
                })
            ) {
                return false
            }

            const result1 = await this.judgeUserGroupInfo()
            if (!result1) {
                return false
            }
            const result2 = await this.judgeCurrentGroupInfoIsValid()
            if (!result2) {
                return false
            }

            const data = {
                type: 2,
                goods: this.groupVipGoodsInfo
            }
            if (this.userInfo.id === this.inviteUserGroupInfo.creator_id) {
                data.showContentType = -999 // 参与自己团
            }

            this.$BuyGroupVip.show(data)
        },
        // 创建订单前判断用户的拼团信息是否可以参团
        judgeUserGroupInfo() {
            return new Promise((resolve) => {
                getUserGroupInfo()
                    .then((res) => {
                        if (res.code === 200 && this.$Utils.isObject(res.data)) {
                            this.userGroupInfo = res.data
                            const { latest_main = {}, latest_join = {} } = this.userGroupInfo
                            if (this.canCreateGroupVipOrder) {
                                resolve(true)
                            } else {
                                resolve(false)
                                const hasJoinInfo = latest_join.join_list?.find((v) => v.user_id === this.userInfo.id) || {}
                                if ((latest_main.status === 1 && this.orderStatus.indexOf(latest_main.order_status) > -1) || (latest_join.status === 1 && this.orderStatus.indexOf(hasJoinInfo.order_status) > -1)) {
                                    this.$Toast.show('您正有一笔拼团订单在待生效中，无法重复发起，请前往订单中心查看')
                                } else if ((latest_main.status === 2 && this.orderStatus.indexOf(latest_main.order_status) > -1) || (latest_join.status === 2 && this.orderStatus.indexOf(hasJoinInfo.order_status) > -1)) {
                                    this.$Toast.show('您已成功拼团开通会员，无法重复发起，请前往订单中心查看')
                                }
                            }
                        } else {
                            resolve(false)
                            this.$Toast.show(res.msg || '获取用户拼团信息失败，请稍后再试')
                        }
                    })
                    .catch((err) => {
                        resolve(false)
                        console.log('[beforeCreateOrderJudge]=======>', err)
                    })
            })
        },
        // 创建订单前判断当团是否可以参团
        judgeCurrentGroupInfoIsValid() {
            return new Promise((resolve) => {
                if (this.group_id <= 0) {
                    resolve(false)
                    this.$Toast.show('当前拼团信息不存在或已失效')
                    return
                }
                getGroupInfo({ id: this.group_id })
                    .then((res) => {
                        if (res.code === 200 && this.$Utils.isObject(res.data)) {
                            const { status, expire_time } = res.data // 0-拼团失败 1-拼团中 2-拼团成功
                            const formatTime = +new Date(expire_time)
                            if (status === 1) {
                                if (this.serverTime * 1000 <= formatTime) {
                                    resolve(true)
                                } else {
                                    resolve(false)
                                    this.$Toast.show('当前拼团已过期，无法再次参团')
                                }
                            } else if (status === 2) {
                                resolve(false)
                                this.$Toast.show('当前拼团已成功，无法再次参团')
                            } else if (status === 3) {
                                resolve(false)
                                this.$Toast.show('当前拼团已失败，无法再次参团')
                            }
                        } else {
                            resolve(false)
                            this.$Toast.show('当前拼团信息不存在或已失效')
                        }
                    })
                    .catch((err) => {
                        resolve(false)
                        console.log('[judgeCurrentGroupInfoIsValid]=======>', err)
                    })
            })
        },
        // 登录
        enterLogin() {
            this.$Login.show({
                scene: 'cb',
                callback: () => {}
            })
        },
        dlBox() {
            this.$EventBus.$emit('app-dl')
        }
    }
}
</script>

<style lang="less" scoped>
.act-group-buy-vip {
    background: url(../../assets/group/group-bg.png) top center no-repeat #070630;

    .scroller {
        .whole-bg {
            margin: 0 auto;
            padding-top: 385px;
            width: 1350px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .login-sec {
                color: #ffc363;
                text-align: center;
                font-size: 24px;
                font-weight: 700;
                margin-bottom: 8.5px;

                .login-btn {
                    cursor: pointer;
                    color: #fdedb9;
                }
            }

            .main-info {
                position: relative;
                width: 1098px;
                height: 439px;
                padding: 35px 0 0;
                margin: 0 auto;
                background: url(../../assets/group/info-bg.png) center/100% no-repeat;

                .title {
                    text-align: center;
                    color: #8b4d09;
                    font-size: 30px;
                    font-weight: 700;
                    line-height: 45px;
                }

                .line {
                    margin: -5px auto 15px;
                    width: 400px;
                    height: 20px;
                    background: url(../../assets/group/line.png) center/100% no-repeat;
                }

                .center-info {
                    display: flex;

                    .goods-info-wrap {
                        display: flex;
                        margin-top: 10px;
                        margin-left: 38px;
                        padding-top: 47px;
                        width: 569px;
                        height: 265px;
                        background: url(../../assets/group/light-yellow.bg.png) center/100% no-repeat;

                        .goods-info {
                            position: relative;
                            left: -7px;
                            width: 282px;
                            height: 150px;
                            margin-right: 7px;
                            flex-shrink: 0;

                            .icon {
                                position: absolute;
                                z-index: 1;
                                top: -18px;
                                right: -11px;
                                width: 88px;
                                height: 64px;
                                background: url(../../assets/act/diamond-m-icon.png) center/100% no-repeat;
                            }

                            .inner {
                                position: relative;
                                width: 262px;
                                height: 137px;

                                &.vip1 {
                                    background: url(../../assets/act/vip1-m.png) left top no-repeat;

                                    .dv1 {
                                        background: linear-gradient(90deg, #a45d1b 4.91%, #835d39 99.84%);
                                        background-clip: text;
                                        -webkit-background-clip: text;
                                        -webkit-text-fill-color: transparent;
                                    }

                                    .dv2 {
                                        .sp1 {
                                            color: #a45d1b;
                                        }

                                        .sp2 {
                                            color: rgba(164, 93, 27, 0.5);

                                            &::after {
                                                background-color: rgba(164, 93, 27, 0.5);
                                            }
                                        }
                                    }

                                    .dv4 {
                                        color: rgba(164, 93, 27, 0.8);
                                        border: 1px solid #e6ad5c;
                                    }
                                }

                                &.vip2 {
                                    background: url(../../assets/act/vip2-m.png) left top no-repeat;

                                    .dv1 {
                                        background: linear-gradient(90deg, #ffe4ca 2.34%, #fffefd 100%);
                                        background-clip: text;
                                        -webkit-background-clip: text;
                                        -webkit-text-fill-color: transparent;
                                    }

                                    .dv2 {
                                        .sp1 {
                                            color: #ffe5cd;
                                        }

                                        .sp2 {
                                            color: #ffe4ca;

                                            &::after {
                                                background-color: #ffe4ca;
                                            }
                                        }
                                    }

                                    .dv4 {
                                        color: #8a95b2;
                                        border: 1px solid #808aa2;
                                    }
                                }

                                &.vip3 {
                                    background: url(../../assets/act/vip3-m.png) left top no-repeat;

                                    .dv1 {
                                        color: rgb(119, 95, 201);
                                    }

                                    .dv2 {
                                        .sp1 {
                                            color: #775fc9;
                                        }

                                        .sp2 {
                                            color: rgba(119, 95, 201, 0.5);

                                            &::after {
                                                background-color: rgba(119, 95, 201, 0.5);
                                            }
                                        }
                                    }

                                    .dv4 {
                                        color: rgba(119, 95, 201, 0.8);
                                        border: 1px solid #afa6e9;
                                    }
                                }

                                .dv1 {
                                    padding-top: 21px;
                                    text-align: center;
                                    font-size: 16px;
                                    font-weight: 700;
                                }

                                .dv2 {
                                    margin-top: 4px;
                                    text-align: center;

                                    .sp1 {
                                        .i0 {
                                            position: relative;
                                            font-size: 12px;
                                            line-height: 18px;
                                            margin: 0 8px;
                                            top: -1px;
                                        }

                                        .i1 {
                                            font-size: 14px;
                                            font-weight: 700;
                                            line-height: 21px;
                                            margin-right: 4px;
                                        }

                                        .i2 {
                                            margin-right: 4px;
                                            font-size: 36px;
                                            font-style: normal;
                                            font-weight: 900;
                                        }
                                    }

                                    .sp2 {
                                        position: relative;
                                        font-size: 12px;
                                        font-weight: 400;
                                        line-height: 18px;

                                        i:first-child {
                                            margin-right: 4px;
                                        }

                                        &::after {
                                            position: absolute;
                                            top: 50%;
                                            left: 50%;
                                            transform: translate(-50%);
                                            content: '';
                                            width: 105%;
                                            height: 1px;
                                        }
                                    }
                                }

                                .dv4 {
                                    position: absolute;
                                    width: 214px;
                                    height: 20px;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    bottom: 15px;
                                    border-radius: 4px;
                                    font-size: 12px;
                                    text-align: center;
                                    line-height: 20px;
                                }
                            }
                        }

                        .user-info {
                            flex-shrink: 0;
                            width: 272px;

                            .title {
                                margin-bottom: 10px;
                                color: #683907;
                                font-size: 16px;
                                font-weight: 700;
                                line-height: 24px;
                            }

                            .price-sec {
                                color: #ea3b3b;

                                .sp1 {
                                    font-size: 12px;
                                }

                                .sp2 {
                                    margin-left: 2px;
                                    font-size: 16px;
                                    font-weight: 900;
                                }

                                .sp3 {
                                    font-size: 24px;
                                    font-weight: 900;
                                    margin-right: 5px;
                                }

                                .sp4 {
                                    color: #916e38;
                                    font-size: 14px;
                                    font-weight: 900;
                                    line-height: 17px;
                                    text-decoration-line: line-through;
                                }
                            }

                            .line {
                                position: relative;
                                left: 6px;
                                width: 266px;
                                height: 22px;
                                background: url(../../assets/act/line.png) center/100% no-repeat;

                                .discount {
                                    position: absolute;
                                    left: 144px;
                                    width: 80px;
                                    top: -24px;
                                    text-align: center;

                                    .dv1 {
                                        color: rgb(234, 59, 59);
                                        font-size: 12px;
                                        line-height: 15px;
                                    }

                                    .dv2 {
                                        font-weight: 900;
                                        color: rgb(234, 60, 60);

                                        .i1 {
                                            font-size: 12px;
                                        }

                                        .i2 {
                                            font-size: 16px;
                                        }
                                    }
                                }
                            }

                            .countdown {
                                display: flex;
                                color: rgb(255, 255, 255);

                                .sp1 {
                                    text-align: center;
                                    line-height: 22px;
                                    font-size: 16px;
                                    width: 36px;
                                    height: 22px;
                                    background: url(../../assets/act/countdown-icon.png) center/100% no-repeat;
                                }

                                .sp2 {
                                    width: 10px;
                                    font-size: 20px;
                                    font-weight: 900;
                                    margin-top: -4px;
                                    padding-left: 2px;
                                }

                                .sp3 {
                                    margin-left: 4px;
                                    color: rgb(145, 110, 56);
                                    font-size: 14px;
                                    line-height: 22px;
                                }
                            }

                            .invite-info {
                                padding-top: 20px;
                                display: flex;
                                flex: 1;

                                .item1,
                                .item2 {
                                    background: url(../../assets/group/icon5.png) center/100% no-repeat;

                                    img {
                                        display: block;
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                        border-radius: 50%;
                                    }
                                }

                                .item1 {
                                    position: relative;
                                    margin-right: 24px;
                                    width: 60px;
                                    height: 60px;
                                    border: 1px solid #f8e3c2;
                                    border-radius: 50%;

                                    .icon {
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        position: absolute;
                                        top: 48px;
                                        left: 50%;
                                        transform: translateX(-50%);
                                        width: 46px;
                                        height: 20px;
                                        border-radius: 10px;
                                        border: 1px solid #faf7f2;
                                        background: #ea3b3b;
                                        color: #ffffff;
                                        font-size: 12px;
                                    }
                                }

                                .item2 {
                                    width: 60px;
                                    height: 60px;
                                }
                            }
                        }
                    }

                    .right-icon {
                        margin: 14px 0 0 14px;
                        display: flex;
                        flex-wrap: wrap;
                        width: 430px;

                        .item {
                            margin: 0 20px 29px 0;
                            padding: 12px 0 0 0;
                            width: 203px;
                            height: 113px;
                            background: url(../../assets/group/icon6.png) center/100% no-repeat;

                            &:nth-child(2n) {
                                margin-right: 0;
                            }

                            .icon {
                                margin: 0 auto;
                                width: 60px;
                                height: 60px;

                                &:nth-child(1) {
                                    background: url(../../assets/group/icon1.png) center/100% no-repeat;
                                }

                                &:nth-child(2) {
                                    background: url(../../assets/group/icon2.png) center/100% no-repeat;
                                }

                                &:nth-child(3) {
                                    background: url(../../assets/group/icon3.png) center/100% no-repeat;
                                }

                                &:nth-child(4) {
                                    background: url(../../assets/group/icon4.png) center/100% no-repeat;
                                }
                            }

                            .text {
                                margin: 5px 0 0 0;
                                text-align: center;
                                color: #333333;
                                font-size: 16px;
                                font-weight: 700;
                                line-height: 24px;
                            }
                        }
                    }
                }

                .btn {
                    position: absolute;
                    display: flex;
                    top: 410px;
                    left: 50%;
                    transform: translateX(-50%);
                    cursor: pointer;
                    width: 228px;
                    height: 53px;
                    color: #ffffff;
                    text-align: center;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 53px;
                    background: url(../../assets/act/share-btn.png) center/100% no-repeat;

                    span {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .vip-goods-wrap {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;

                .item {
                    position: relative;
                    width: 300px;
                    border-radius: 12px;
                    transition: 0.3s;
                    margin-right: 45px;
                    cursor: pointer;

                    &:last-child {
                        margin-right: 0;
                    }

                    .inner {
                        position: relative;
                        height: 157px;
                        overflow: hidden;
                    }

                    .icon {
                        position: absolute;
                        top: -27px;
                        right: -21px;
                        width: 108px;
                        height: 78px;
                        background: url(../../assets/act/diamond-icon.png) center/100% no-repeat;
                    }

                    .dv1 {
                        padding-top: 31px;
                        text-align: center;
                        line-height: 27px;
                        font-size: 18px;
                        font-weight: 700;
                    }

                    .dv2 {
                        margin-top: 4px;
                        text-align: center;

                        .sp1 {
                            .i0 {
                                position: relative;
                                font-size: 12px;
                                line-height: 18px;
                                margin: 0 8px;
                                top: -1px;
                            }

                            .i1 {
                                font-size: 14px;
                                font-weight: 700;
                                line-height: 21px;
                                margin-right: 4px;
                            }

                            .i2 {
                                margin-right: 4px;
                                font-size: 40px;
                                font-style: normal;
                                font-weight: 900;
                            }
                        }

                        .sp2 {
                            position: relative;
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 18px;

                            i:first-child {
                                margin-right: 4px;
                            }

                            &::after {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%);
                                content: '';
                                width: 105%;
                                height: 1px;
                            }
                        }
                    }

                    .dv4 {
                        position: absolute;
                        width: 214px;
                        height: 20px;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: 18px;
                        border-radius: 4px;
                        font-size: 12px;
                        text-align: center;
                        line-height: 20px;
                    }

                    &.vip1 {
                        background: url(../../assets/act/vip1.png) left top no-repeat;

                        .dv1 {
                            background: linear-gradient(90deg, #a45d1b 4.91%, #835d39 99.84%);
                            background-clip: text;
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }

                        .dv2 {
                            .sp1 {
                                color: #a45d1b;
                            }

                            .sp2 {
                                color: rgba(164, 93, 27, 0.5);

                                &::after {
                                    background-color: rgba(164, 93, 27, 0.5);
                                }
                            }
                        }

                        .dv4 {
                            color: rgba(164, 93, 27, 0.8);
                            border: 1px solid #e6ad5c;
                        }
                    }

                    &.vip2 {
                        background: url(../../assets/act/vip2.png) left top no-repeat;

                        .dv1 {
                            background: linear-gradient(90deg, #ffe4ca 2.34%, #fffefd 100%);
                            background-clip: text;
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }

                        .dv2 {
                            .sp1 {
                                color: #ffe5cd;
                            }

                            .sp2 {
                                color: #ffe4ca;

                                &::after {
                                    background-color: #ffe4ca;
                                }
                            }
                        }

                        .dv4 {
                            color: #8a95b2;
                            border: 1px solid #808aa2;
                        }
                    }

                    &.vip3 {
                        background: url(../../assets/act/vip3.png) left top no-repeat;

                        .dv1 {
                            color: rgb(119, 95, 201);
                        }

                        .dv2 {
                            .sp1 {
                                color: #775fc9;
                            }

                            .sp2 {
                                color: rgba(119, 95, 201, 0.5);

                                &::after {
                                    background-color: rgba(119, 95, 201, 0.5);
                                }
                            }
                        }

                        .dv4 {
                            color: rgba(119, 95, 201, 0.8);
                            border: 1px solid #afa6e9;
                        }
                    }

                    .buy-btn-sec {
                        margin-top: 18px;
                        display: flex;
                        justify-content: center;

                        .lf-btn {
                            padding-left: 38px;
                            width: 136px;
                            height: 48px;
                            background: url(../../assets/act/lf-btn.png) center/100% no-repeat;
                            color: #ffffff;
                            font-size: 20px;
                            font-weight: 700;
                            line-height: 48px;
                        }

                        .rg-btn {
                            position: relative;
                            padding-top: 10px;
                            margin-left: -5px;
                            padding-left: 19px;
                            width: 157px;
                            height: 48px;
                            background: url(../../assets/act/rg-btn.png) center/100% no-repeat;

                            span {
                                vertical-align: middle;
                            }

                            .sp1 {
                                position: relative;
                                top: 3px;
                                color: #e6262c;
                                font-size: 16px;
                                font-weight: 400;
                                line-height: 24px;
                            }

                            .sp2 {
                                display: inline-block;
                                max-width: 50px;
                                color: #e6262c;
                                font-size: 24px;
                                font-weight: 700;
                                margin-right: 8px;
                            }

                            .sp3 {
                                position: relative;
                                top: 3px;
                                color: #8c7f42;
                                font-size: 16px;
                                font-weight: 400;
                                line-height: 24px;
                            }

                            .right-top {
                                position: absolute;
                                flex-wrap: nowrap;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                top: -9px;
                                right: 0;
                                width: 64px;
                                height: 22px;
                                background: url(../../assets/act/pop-icon.png) center/100% no-repeat;
                                color: #ffca1b;
                                font-size: 12px;

                                span {
                                    max-width: 60px;
                                }
                            }

                            .bottom-text {
                                position: absolute;
                                right: 0;
                                bottom: -26px;
                                color: #ffca1b;
                                font-size: 16px;

                                &.white-color {
                                    color: #ffffff;
                                }
                            }
                        }
                    }
                }
            }

            .activity-rules {
                width: 1094px;
                margin: 116px auto 113px;

                .rules-title {
                    text-align: center;
                    color: #d3dfff;
                    font-size: 30px;
                    font-weight: 700;
                    line-height: 45px;
                }

                .divide-line {
                    margin: 2px auto 23px;
                    width: 400px;
                    height: 20px;
                    background: url(../../assets/act/divide-line.png) center/100% no-repeat;
                }

                .rules-cnt {
                    margin-bottom: 24px;
                    color: #e8eeff;

                    .one-level {
                        margin: 0 0 12px;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 24px;
                    }

                    .two-level {
                        display: flex;
                        color: #d3dfff;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 24px;
                        margin-bottom: 8px;
                        width: 1072px;

                        .icon {
                            flex-shrink: 0;
                            margin: 7px 7px 0 5px;
                            width: 10px;
                            height: 10px;
                            margin-right: 6px;
                            background: url(../../assets/act/square-icon.png) center/100% no-repeat;
                        }

                        .dv {
                            flex: 1;
                        }
                    }
                }
            }
        }
    }
}
</style>
